import { Button, Checkbox, message, Popconfirm, Space, Table } from 'antd';
import classnames from 'classnames';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import Loading from '../../components/Loading';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';
import TypeApi, { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import ButtonFeatured from './ButtonFeatured';
import ButtonHide from './ButtonHide';
import ButtonView from './ButtonView';

class ListVehiclePartner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicleType: VEHICLE_TYPES.CAR,
      types: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const types = (await TypeApi.getAll()) || [];

    const listCars = await VehiclePartnerApi.getAllVehiclePartner({
      vhc_type_id: VEHICLE_TYPES.CAR,
    });

    this.setState({
      vehicles: listCars,
      types,
    });
  }

  handleChangeHide = async (checked, row) => {
    await VehiclePartnerApi.updateSimple(row.vhc_type_id, checked);
  };

  buttonHide = (cell, row) => {
    return <ButtonHide cell={cell} row={row} />;
  };

  buttonFeatured = (cell, row) => {
    return <ButtonFeatured cell={cell} row={row} />;
  };

  handleInsertButtonClick = () => {
    const { selectedVehicleType } = this.state;
    const { match_parent } = this.props;
    if (selectedVehicleType === VEHICLE_TYPES.CAR) {
      return this.props.history.push(`${match_parent.url}/add-car-partner`);
    }

    return this.props.history.push(`${match_parent.url}/add-motorbike-partner`);
  };

  handleChangeList = (list) => {
    const { selectedVehicleType } = this.state;
    if (selectedVehicleType === VEHICLE_TYPES.CAR)
      this.setState({ listCars: list });
    else this.setState({ listMotorbikes: list });
  };

  toggle = async (newlySelectedVhcType) => {
    const { selectedVehicleType } = this.state;

    if (selectedVehicleType !== newlySelectedVhcType) {
      this.setState({
        selectedVehicleType: newlySelectedVhcType,
        vehicles: [],
      });
    }

    const result = await VehiclePartnerApi.getAllVehiclePartner({
      vhc_type_id: Number(newlySelectedVhcType),
    });

    const vehicles = MyUtil.formatListVehicle(result, newlySelectedVhcType);
    this.setState({ vehicles });
  };

  renderVhcSeatNum = (cellValue, row) => {
    return `${cellValue} chỗ`;
  };

  handleDelete = async (key) => {
    try {
      const { vehicles } = this.state;
      await VehiclePartnerApi.deleteVehiclePartner(key);

      message.success('Xóa xe thành công, mã xe = ' + key);

      this.setState({
        vehicles: vehicles.filter((vp) => vp.vhc_part_id !== key),
      });
    } catch (e) {
      message.error(`Lỗi: ${e.message}`);
    }
  };

  render() {
    const { types, vehicles, selectedVehicleType } = this.state;
    if (types.length === 0) {
      return <Loading />;
    }

    const { match_parent } = this.props;
    const canAdd = MyUtil.hasPermission(match_parent.url, 'add');
    const canDelete = MyUtil.hasPermission(match_parent.url, 'delete');

    const columnCars = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_part_id',
        key: 'vhc_part_id',
        fixed: 'left',
      },
      {
        title: 'Tên đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('part_name'),
      },
      {
        title: 'Xe ở thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
        ...TableUtils.getColumnDropDownFilter(vehicles, 'city_name'),
      },
      {
        title: 'Quận',
        dataIndex: 'district_name',
        key: 'district_name',
        ...TableUtils.getColumnDropDownFilter(vehicles, 'district_name'),
      },
      {
        title: 'Địa chỉ xe',
        dataIndex: 'vhc_part_addr',
        key: 'vhc_part_addr',
        ...TableUtils.getColumnSearchProps('vhc_part_addr'),
      },
      {
        title: 'Tên xe',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        ...TableUtils.getColumnSearchProps('vhc_part_name'),
      },
      {
        title: 'Năm SX',
        dataIndex: 'vhc_part_year',
        key: 'vhc_part_year',
        ...TableUtils.getColumnDropDownFilter(vehicles, 'vhc_part_year'),
      },
      {
        title: 'Số chỗ',
        dataIndex: ['vhc', 'vhc_seat_num'],
        align: 'right',
        render: this.renderVhcSeatNum,
        ...TableUtils.getColumnDropDownFilter(vehicles, [
          ['vhc', 'vhc_seat_num'],
        ]),
      },
      {
        title: 'Hình dáng',
        dataIndex: ['vhc', 'vhc_dgn_name'],
        ...TableUtils.getColumnDropDownFilter(vehicles, [
          ['vhc', 'vhc_dgn_name'],
        ]),
      },
      {
        title: 'Động cơ',
        dataIndex: ['vhc', 'vhc_tms_name'],
        ...TableUtils.getColumnDropDownFilter(vehicles, [
          ['vhc', 'vhc_tms_name'],
        ]),
      },
      {
        title: 'Giá cơ bản',
        dataIndex: 'vhc_part_defa_prie',
        key: 'vhc_part_defa_prie',
        align: 'right',
        render(cell) {
          return MyUtil.currencyFormat(cell);
        },
      },
      {
        title: 'Ẩn xe',
        render: this.buttonHide,
        filterDropdown: ({ setSelectedKeys, confirm }) => (
          <div style={{ padding: 10 }}>
            <Checkbox
              onChange={({ target: { checked } }) => {
                setSelectedKeys([checked]);
                confirm();
              }}
            >
              Chỉ hiện xe đang khai thác
            </Checkbox>
          </div>
        ),
        onFilter(value, record) {
          if (value) {
            return !record.vhc_part_hide;
          }

          return true;
        },
      },
      {
        title: 'Đánh dấu nổi bật',
        render: this.buttonFeatured,
      },
      {
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/vehicle-partner/edit-car-vehicle-partner/${record.vhc_part_id}`
                  )
                }
              >
                <i className="fas fa-edit"></i>
              </Button>

              <ButtonView
                vehiclePartner={record}
                onChangeList={this.handleChangeList}
              />
              {canDelete && (
                <Popconfirm
                  title="Bạn chắc chắn muốn xóa?"
                  onConfirm={() => this.handleDelete(record.vhc_part_id)}
                >
                  <Button size="small" danger>
                    <i className="fas fa-trash"></i>
                  </Button>
                </Popconfirm>
              )}
            </Space>
          );
        },
      },
    ];

    const columnMotobikes = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_part_id',
        key: 'vhc_part_id',
        fixed: 'left',
      },
      {
        title: 'Tên đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('part_name'),
      },
      {
        title: 'Thành phố của đối tác',
        dataIndex: 'city_name',
        key: 'city_name',
        ...TableUtils.getColumnDropDownFilter(vehicles, 'city_name'),
      },
      {
        title: 'Quận',
        dataIndex: 'district_name',
        key: 'district_name',
        ...TableUtils.getColumnDropDownFilter(vehicles, 'district_name'),
      },
      {
        title: 'Địa chỉ xe',
        dataIndex: 'vhc_part_addr',
        key: 'vhc_part_addr',
        ...TableUtils.getColumnSearchProps('vhc_part_addr'),
      },
      {
        title: 'Tên xe',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        ...TableUtils.getColumnSearchProps('vhc_part_name'),
      },
      {
        title: 'Giá cơ bản',
        dataIndex: 'vhc_part_defa_prie',
        key: 'vhc_part_defa_prie',
      },
      {
        title: 'SL',
        dataIndex: 'vhc_part_qaty_aval',
        key: 'vhc_part_qaty_aval',
      },
      {
        title: 'Ẩn hiện xe',
        render: this.buttonHide,
      },
      {
        title: 'Đánh dấu nổi bật',
        render: this.buttonFeatured,
      },
      {
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/vehicle-partner/edit-moto-vehicle-partner/${record.vhc_part_id}`
                  )
                }
              >
                <i className="fas fa-edit"></i>
              </Button>
              <ButtonView
                vehiclePartner={record}
                onChangeList={this.handleChangeList}
              />
              {canDelete && (
                <Popconfirm
                  title="Bạn chắc chắn muốn xóa?"
                  onConfirm={() => this.handleDelete(record.vhc_part_id)}
                >
                  <Button size="small" danger>
                    <i className="fas fa-trash"></i>
                  </Button>
                </Popconfirm>
              )}
            </Space>
          );
        },
      },
    ];

    return (
      <>
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              className={classnames(
                { active: selectedVehicleType === VEHICLE_TYPES.CAR },
                'nav-tab'
              )}
              onClick={() => this.toggle(VEHICLE_TYPES.CAR)}
            >
              Ô TÔ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(
                { active: selectedVehicleType === VEHICLE_TYPES.MOTOBIKE },
                'nav-tab'
              )}
              onClick={() => this.toggle(VEHICLE_TYPES.MOTOBIKE)}
            >
              XE MÁY
            </NavLink>
          </NavItem>
        </Nav>

        {canAdd && (
          <div>
            <Button
              onClick={this.handleInsertButtonClick}
              type="primary"
              size="large"
            >
              Thêm
            </Button>
          </div>
        )}

        <Table
          className="mt-2"
          rowKey="vhc_part_id"
          size="small"
          columns={
            selectedVehicleType === VEHICLE_TYPES.CAR
              ? columnCars
              : columnMotobikes
          }
          dataSource={vehicles}
          scroll={{ x: 'max-content' }}
        />
      </>
    );
  }
}

export default withRouter(ListVehiclePartner);
